import posNotificationInstance from '../instance'

const getNotifications = () => {
	return posNotificationInstance.get('notifications')
}

export default getNotifications
